module.exports = __webpack_public_path__ + "img/library-welcome.b46c94e6.png";